import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

import AdminLayout from "@/layouts/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import CreateOrder from "@/pages/admin/CreateOrder";
import Customers from "@/pages/admin/Customers";
import Drivers from "@/pages/admin/Drivers";
import History from "@/pages/admin/History";
import MapView from "@/pages/admin/MapView";
import Reports from "@/pages/admin/Reports";
import Settings from "@/pages/admin/Settings";
import PODView from "@/pages/admin/PODView";
import BookingSlip from "@/pages/admin/BookingSlip";

import DriverLayout from "@/layouts/DriverLayout";
import DriverHome from "@/pages/driver/DriverHome";
import DeliveryDetail from "@/pages/driver/DeliveryDetail";
import DriverHistory from "@/pages/driver/DriverHistory";
import DriverProfile from "@/pages/driver/DriverProfile";

function RootRedirect() {
  const { user, checked } = useAuth();
  if (!checked) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "driver" ? "/driver" : "/admin"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/admin" element={<ProtectedRoute roles={["admin", "dispatch"]}><AdminLayout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/new" element={<CreateOrder />} />
            <Route path="customers" element={<Customers />} />
            <Route path="drivers" element={<Drivers />} />
            <Route path="history" element={<History />} />
            <Route path="map" element={<MapView />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
            <Route path="pod/:id" element={<PODView />} />
            <Route path="booking/:id" element={<BookingSlip />} />
          </Route>

          <Route path="/driver" element={<ProtectedRoute roles={["driver"]}><DriverLayout /></ProtectedRoute>}>
            <Route index element={<DriverHome />} />
            <Route path="delivery/:id" element={<DeliveryDetail />} />
            <Route path="history" element={<DriverHistory />} />
            <Route path="profile" element={<DriverProfile />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
